<template>
  <section class="mega-about-section bg-gradient-to-br from-green-400 to-green-500 relative overflow-hidden">
    <!-- Decorative elements -->
    <div class="absolute top-0 left-0 w-full h-full opacity-10">
      <div class="absolute top-20 left-10 w-40 h-40 bg-white/20 rounded-full filter blur-xl"></div>
      <div class="absolute bottom-10 right-20 w-60 h-60 bg-green-400/30 rounded-full filter blur-xl"></div>
    </div>
    
    <div class="relative z-10">
      <h1 class="mega-title text-white font-bold">
        {{ t('aboutHeader') }}
        <span class="mega-title-underline"></span>
      </h1>
      
      <div class="mega-content">
        <div 
          v-for="(feature, index) in features" 
          :key="index"
          class="mega-feature"
          :style="`--delay: ${index * 0.1}s`"
        >
          <div class="mega-icon-wrapper">
            <img 
              :src="feature.image" 
              :alt="feature.title"
              class="mega-image"
            />
            <div class="mega-image-overlay">
              <span class="mega-image-caption">{{ feature.caption }}</span>
            </div>
          </div>
          <h2 class="mega-feature-title"><b> {{ feature.title }} </b></h2>
          <p class="mega-feature-desc">{{ feature.description }}</p>
          <div class="mega-feature-hover"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const features = [  
  {
    image: '/img/technic.png', // Use correct path for public images
    title: t('features.title1'),
    caption: 'Notre équipe certifiée',
    description: t('description.about1')
  },
  {
    image: '', // External image works as is
    image: '/img/CarteElectronique.jpg', // Correct path
    title: t('features.title2'),
    caption: 'Matériel haute performance',
    description: t('description.about2')
  },
  {
    image: '/img/n3.png', // Correct path
    title: t('features.title3'),
    caption: 'Installation professionnelle',
    description: t('description.about3')
  }
]
</script>




<style scoped>
.mega-about-section {
  padding: 6rem 2rem;
  text-align: center;
  position: relative;
}

.mega-title {
  font-size: 2.8rem;
  margin-bottom: 5rem;
  display: inline-block;
  position: relative;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.mega-title-underline {
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 4px;
  background: linear-gradient(90deg, #FFD700, #FFFFFF);
  border-radius: 2px;
  box-shadow: 0 2px 10px rgba(255, 215, 0, 0.5);
}

.mega-content {
  display: flex;
  justify-content: center;
  gap: 2.5rem;
  flex-wrap: wrap;
  max-width: 1300px;
  margin: 0 auto;
}

.mega-feature {
  flex: 1;
  min-width: 300px;
  max-width: 380px;
  text-align: center;
  padding: 2.5rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 15px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;
  z-index: 1;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.mega-feature:hover {
  transform: translateY(-15px) scale(1.02);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2);
}

.mega-icon-wrapper {
  width: 260px;
  height: 260px;
  margin: 0 auto 2rem;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  transition: all 0.4s ease;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.mega-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.4s ease;
}

.mega-image-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 1.5rem;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  opacity: 0;
  transition: opacity 0.3s ease;
}

.mega-image-caption {
  color: white;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.mega-feature:hover .mega-image-overlay {
  opacity: 1;
}

.mega-feature:hover .mega-image {
  transform: scale(1.1);
}

/* Rest of the styles remain similar */
</style>